import React from 'react';

import { LayoutRoot } from './Layout';

/**
 * A basic template for a Page
 */
export function Page({
    ref,
    ...props
}: { children: React.ReactNode; className?: string } & { ref?: React.Ref<HTMLDivElement> }) {
    const { children, className, ...rest } = props;

    return (
        <LayoutRoot ref={ref} layout="centered" className={className} {...rest}>
            {children}
        </LayoutRoot>
    );
}
